import { Context } from '@nuxt/types';
import articleUrl, { buildArticleCommentsUrl as articleCommentsUrl } from '@root/modules/article/utils/buildArticleUrl';
import matchChannel from '@root/common/utils/matchChannel';
import { Data as ArticleData } from '@root/modules/article/types/article';
import getChannelDomain from '@root/modules/channel/utils/getChannelDomain';

const errorMessage = {
  message: 'article.error.not_found',
  statusCode: 404,
};

const getArticlePath = async (context: Context) => {
  const { error, store } = context;

  try {
    const { article }: { article: ArticleData } = store.getters['article/getTempData'];

    if (article) {
      const { app } = context;
      const { id } = app.$channelConfig('settings');
      const domain = getChannelDomain(id) || 'www.delfi.lt';
      const fakeDomainEnabled = context.$config.FAKE_DOMAIN_ENABLED;

      // Handle short URL
      const isShortUrl = context.route.path.includes('/a/');
      if (isShortUrl) {
        const isCommentsUrl = context.route.path.includes('/diskusija');
        return isCommentsUrl ? articleCommentsUrl({ article, domain, fakeDomainEnabled }) : articleUrl({ article, domain, fakeDomainEnabled });
      }

      const activeDomain = article.primaryCategory?.channel?.url;

      if (!activeDomain) {
        return false;
      }

      const sameChannel = matchChannel(domain, activeDomain);
      if (sameChannel) {
        return false;
      } else {
        // Redirect article if it does not belong to active channel
        return articleUrl({ article, domain, fakeDomainEnabled });
      }
    } else {
      error(errorMessage);
    }
  } catch (e) {
    error(errorMessage);
  }
  return false;
};

export default getArticlePath;
